import {useEffect, useState} from 'react'
import {InvoiceModalHeader} from './InvoiceModalHeader'
import {franchiseInvoice} from '../../../../core/_models'
import {getInvoice} from '../../core/_requests'
import {formatMonetaryToBr} from '../../../../../../utils/formatMonetaryToBr'
import Swal from 'sweetalert2'
import {ListLoading} from '../loading/ListLoading'
import {formatDate} from '../../../../../../utils/dayJs/format'

interface IInvoiceInfo {
  invoiceId: number
  franchiseId: number
}
const InvoiceModal = ({invoiceId, franchiseId}: IInvoiceInfo) => {
  const [invoiceCurrentUsage, setInvoiceCurrentUsage] = useState<franchiseInvoice>()
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    const loadInvoice = async () => {
      try {
        setIsLoading(true)
        const response = await getInvoice(invoiceId, franchiseId)
        setInvoiceCurrentUsage(response)
      } catch (error: any) {
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: error?.response?.data?.message,
          showConfirmButton: true,
        })
      } finally {
        setIsLoading(false)
      }
    }
    loadInvoice()
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-950px'>
          <div className='modal-content'>
            {isLoading ? (
              <ListLoading />
            ) : (
              <>
                <InvoiceModalHeader invoiceCurrentUsage={invoiceCurrentUsage} />

                <div className='card shadow-sm border-0 rounded-4'>
                  <div className='card-body p-5'>
                    <div className='row mb-5'>
                      <div className='col-md-6 mb-4'>
                        <div className='border rounded-3 p-4 h-100'>
                          <h6 className='text-muted mb-2'>EMITENTE</h6>
                          <p className='fw-bold mb-0'>{invoiceCurrentUsage?.franchise?.name}</p>
                        </div>
                      </div>
                      <div className='col-md-6 mb-4'>
                        <div className='border rounded-3 p-4 h-100'>
                          <h6 className='text-muted mb-2'>FRANQUIA</h6>
                          <p className='fw-bold mb-0'>{invoiceCurrentUsage?.billingEntity?.name}</p>
                        </div>
                      </div>
                      <div className='col-md-4 mb-4'>
                        <div className='border rounded-3 p-4 h-100'>
                          <h6 className='text-muted mb-2'>PERÍODO DE REFERÊNCIA</h6>
                          <p className='fw-bold mb-0'>{`${formatDate(
                            invoiceCurrentUsage?.referenceStart || ''
                          )} - ${formatDate(invoiceCurrentUsage?.referenceEnd || '')}`}</p>
                        </div>
                      </div>

                      <div className='col-md-4 mb-4'>
                        <div className='border rounded-3 p-4 h-100'>
                          <h6 className='text-muted mb-2'>VENCIMENTO</h6>
                          <p className='fw-bold mb-0'>
                            {formatDate(invoiceCurrentUsage?.dueDate || '')}
                          </p>
                        </div>
                      </div>

                      <div className='col-md-4 mb-4'>
                        <div className='border rounded-3 p-4 h-100'>
                          <h6 className='text-muted mb-2'>TOTAL DE REQUISIÇÕES</h6>
                          <p className='fw-bold mb-0'>
                            {formatMonetaryToBr(invoiceCurrentUsage?.totalAmount)}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className='table-responsive'>
                      <table className='table table-row-bordered align-middle gy-4'>
                        <thead>
                          <tr className='fw-bold text-muted bg-light'>
                            <th>Descrição</th>
                            <th>Qtd</th>
                            <th>Valor unit.</th>
                            <th>Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          {invoiceCurrentUsage?.items.map((item, index) => (
                            <tr key={item.id}>
                              <td>{item.description}</td>
                              <td>{item.quantity}</td>
                              <td>{formatMonetaryToBr(item.unitPrice)}</td>
                              <td>{formatMonetaryToBr(item.amount)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className='d-flex justify-content-center mt-5'>
                      <div className='border rounded-3 p-4 text-center min-w-250px'>
                        <h5 className='text-muted mb-2'>Valor Total</h5>
                        <h1 className='fw-bold text-danger'>
                          {formatMonetaryToBr(invoiceCurrentUsage?.totalAmount)}
                        </h1>
                      </div>
                    </div>

                    <div className='text-center text-muted mt-5'>
                      Gerado em {new Date().toLocaleDateString('pt-BR')} ·{' '}
                      {invoiceCurrentUsage?.referenceCode} ·{' '}
                      {invoiceCurrentUsage?.billingEntity?.name}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {InvoiceModal}
